import { init as initHeader } from '../../commons/header/header';

//---
/*
  eslint-disable no-underscore-dangle
*/

const CANCEL_FAVORITE_STORE =
  'rest/model/atg/userprofiling/ProfileActor/cancelUsualStore';
const SET_FAVORITE_STORE =
  'rest/model/atg/userprofiling/ProfileActor/setUsualStore';

export function init() {

  $('input:checkbox[id=favorite-store]').on('change', e => {
    e.preventDefault();
    const currentStore = $(e.target);
    if (currentStore.is(':checked')) {
      setFavoriteStore(currentStore);
    } else {
      cancelFavoriteStore(currentStore);
    }
  });

}

/**
 *
 *
 * @param {Object} currentStore (jQuery Object)
 */
function cancelFavoriteStore(currentStore) {
  window
    .getAjaxHandler()
    .withCaller(currentStore)
    .withUrl(CANCEL_FAVORITE_STORE)
    .withParameters({})
    .withSuccess(cancelFavoriteStoreSuccess)
    .withError(() => {})
    .call();
}

/**
 *
 *
 * @param {Object} currentStore (jQuery Object)
 */
function setFavoriteStore(currentStore) {
  const storeId = $('#favorite-store').data('storeid');
  const params = { storeId };

  window
    .getAjaxHandler()
    .withCaller(currentStore)
    .withUrl(SET_FAVORITE_STORE)
    .withParameters(params)
    .withSuccess(setFavoriteStoreSuccess)
    .withError(() => {})
    .call();
}

function setFavoriteStoreSuccess() {
  if (!$('#favorite-store').data('cancellable')) {
    $('#favorite-store').prop('disabled', true);
  }
  // Hide the "Select as Favorite" label
  $('#select-favorite-store').hide();
  // Display the "My Favorite" label
  $('#is-favorite-store').toggle();

  cube
    .cartridge('header-my-account')
    .after(window.AccountUtils._reloadHeaderMyAccountSuccessError)
    .reload();

  cube
    .cartridge('header-store')
    .after(initHeader)
    .reload();

  cube
    .cartridge('header-help')
    .after(window.AccountUtils._reloadHeaderHelpCenterSuccessError)
    .reload();
}

function cancelFavoriteStoreSuccess() {
  // Display the "My Favorite" label
  $('#is-favorite-store').hide();
  // Hide the "Select as Favorite" label
  $('#select-favorite-store').toggle();

  cube
    .cartridge('header-my-account')
    .after(window.AccountUtils._reloadHeaderMyAccountSuccessError)
    .reload();

  cube
    .cartridge('header-store')
    .after(initHeader)
    .reload();

  cube
    .cartridge('header-help')
    .after(window.AccountUtils._reloadHeaderHelpCenterSuccessError)
    .reload();

}



// WEBPACK FOOTER //
// ./src/store/store-page/accountStoreModule.js